import React, { useEffect, useState } from "react";
import Style from "./BaseLayout.module.scss";
import NavbarEn from "./NavbarEn";
import HomeEn from "./home/HomeEn";
import AboutEn from "./about/AboutEn";
import NotFound from "./NotFound";
import CurvedScrollbar from "./CurvedScrollbar";
import { Route, Routes } from "react-router-dom";
import { Box, Grid } from "@mui/material";

function readDarkModePreference() {
  try {
    return localStorage.getItem("darkMode") === "true";
  } catch {
    return false;
  }
}

export default function BaseLayoutEn() {
  const [darkMode, setDarkMode] = useState(false);

  function handleToggleDarkMode() {
    const next = !darkMode;
    try {
      localStorage.setItem("darkMode", String(next));
    } catch {
      /* ignore quota / private mode */
    }
    setDarkMode(next);
  }

  useEffect(() => {
    setDarkMode(readDarkModePreference());
  }, []);

  return (
    <CurvedScrollbar darkMode={darkMode}>
      <Box className={darkMode ? Style.dark : Style.light}>
        <Grid
          container
          display={"flex"}
          flexDirection={"column"}
          minHeight={"100vh"}
          justifyContent={"space-between"}
        >
          <Grid item>
            <NavbarEn darkMode={darkMode} handleClick={handleToggleDarkMode} />
          </Grid>
          <Grid item flexGrow={1}>
            <Routes>
              <Route path={"/"} element={<HomeEn />} />
              <Route path={"/about"} element={<AboutEn />} />
              <Route path={"/en"} element={<HomeEn />} />
              <Route path={"/en/"} element={<HomeEn />} />
              <Route path={"/en/about"} element={<AboutEn />} />
              <Route path={"*"} element={<NotFound lang="en" />} />
            </Routes>
          </Grid>
          <Grid item>
            <Box
              component={"footer"}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              py={"1.5rem"}
              sx={{ opacity: 0.7 }}
              width={"100%"}
            >
              <p>
                This website is created with ❤️ by{" "}
                <a href={"https://www.berkantaslan.com"}>Berkant Aslan</a>.
              </p>
              <p>&copy; 2026</p>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </CurvedScrollbar>
  );
}
